import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance } from 'vue';
import { convertFileToAntdFile } from '@/helpers/CmsIndexHelper';
import { UploadFile } from 'ant-design-vue/types/upload';
import Attachment from '@/models/Attachment';
import Image from '@/models/Image';
// @ts-ignore
import downloadFile from 'downloadjs';

interface Props {
    attachments: Attachment[];
    isDisabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AttachmentList',
  props: {
    attachments: null,
    isDisabled: { type: Boolean, default: true }
  },
  emits: ["removeFile"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'removeFile', file: UploadFile): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { attachments: Attachment[], isDisabled: boolean };





const { proxy } = getCurrentInstance()!;

const antdAttachments = computed(() => {
    return props.attachments.map((attachment: Attachment) => convertFileToAntdFile(attachment));
});

function customRequest(_data: unknown) {
    return undefined;
}

async function onPreview(file: UploadFile & Image) {
    let blob;
    try {
        blob = await Attachment.getBlob(file.url as string);
    } catch (e) {
        let error;

        if (e instanceof Error) {
            error = e.message;
        } else {
            error = (e as { response: { data: { meta: { message: string } } } }).response.data.meta.message;
        }

        (proxy as any).$notification.error({
            message: (proxy as any).$t('Dogodila se greška') as string,
            description: error,
        });
        return;
    }
    downloadFile(blob.data, file.name);
}

function onRemove(file: UploadFile) {
    emit('removeFile', file);
}

return { __sfc: true,props, emit, proxy, antdAttachments, customRequest, onPreview, onRemove }
}

})